export const showContact = () => {
  const iframe = document.getElementById('s-chat-plugin') as HTMLIFrameElement
  if (!iframe) return
  const chatBtn = iframe.contentWindow?.document?.querySelector(
    '.Chat_icon__wrap_3840H',
  ) as HTMLElement
  if (chatBtn) chatBtn.click()
}
